import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
    state: () => ({
        authToken: null
    }),

    getters: {
        token: (state) => state.authToken,
        isAuthenticated: (state) => !!state.authToken
    },

    persist: true
});
